




































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Feedback extends Vue {
  data() {
    return {
      feedback: [
        {
          name: "Mosan Cameron, ",
          position: "Executive of fedex",
          img: require("../assets/client/client_1.png"),
          content:
            "Also made from. Give may saying meat there from heaven it lights face had is gathered god dea earth light for life may itself shall whales made they're blessed whales also made from give may saying meat. There from heaven it lights face had amazing place"
        },
        {
          name: "Mosan Cameron, ",
          position: "Executive of fedex",
          img: require("../assets/client/client_1.png"),
          content:
            "Also made from. Give may saying meat there from heaven it lights face had is gathered god dea earth light for life may itself shall whales made they're blessed whales also made from give may saying meat. There from heaven it lights face had amazing place"
        },
        {
          name: "Mosan Cameron, ",
          position: "Executive of fedex",
          img: require("../assets/client/client_1.png"),
          content:
            "Also made from. Give may saying meat there from heaven it lights face had is gathered god dea earth light for life may itself shall whales made they're blessed whales also made from give may saying meat. There from heaven it lights face had amazing place"
        }
      ]
    };
  }
}
